import { StyleSheet, Text, View } from 'react-native';

import Feather from '@expo/vector-icons/Feather';

import { colors } from '../theme';
import { inter400, inter500 } from '../utils/platform';

export type WorkExperienceItemProps = {
  role: string;
  company: string;
  description: string;
  techStack?: string;
  period?: string;
  location?: string;
};

export function WorkExperienceItem({
  role,
  company,
  description,
  techStack,
  period,
  location,
}: WorkExperienceItemProps) {
  return (
    <View style={styles.card}>
      <View style={styles.title}>
        {location ? (
          <View style={styles.locationRow}>
            <View style={styles.locationGroup}>
              <View style={styles.icon14}>
                <Feather name="map-pin" size={14} color={colors.muted} />
              </View>
              <Text style={styles.metaText}>{location}</Text>
            </View>

            {period ? <Text style={styles.metaText}>{period}</Text> : null}
          </View>
        ) : null}

        <Text style={styles.role}>{role}</Text>
        <Text style={styles.metaText}>{company}</Text>
        {techStack ? <Text style={styles.stackText}>Tech stack: {techStack}</Text> : null}
      </View>

      <Text style={styles.paragraph}>{description}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    borderColor: colors.border,
    borderLeftWidth: 1,
    gap: 32,
    overflow: 'hidden',
    paddingLeft: 16,
    width: '100%',
  },
  title: {
    gap: 8,
    overflow: 'hidden',
    width: '100%',
  },
  locationRow: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 10,
    overflow: 'hidden',
    width: '100%',
  },
  locationGroup: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
    gap: 6,
    overflow: 'hidden',
  },
  icon14: {
    height: 14,
    width: 14,
  },
  metaText: {
    color: colors.muted,
    fontFamily: inter400,
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 19.6,
  },
  role: {
    color: colors.text,
    fontFamily: inter500,
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 19.2,
  },
  stackText: {
    color: colors.muted,
    fontFamily: inter500,
    fontSize: 13,
    fontWeight: '500',
    lineHeight: 18.2,
  },
  paragraph: {
    color: colors.muted,
    fontFamily: inter400,
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 22.4,
  },
});
